/* Zavika: klik op een kaart-swatch wisselt de productfoto op de kaart naar de
   variant-afbeelding van die kleur. Gedelegeerd op document-niveau zodat het ook
   werkt voor door de slider gekloonde kaarten. */
(function () {
  function biggerUrl(src) {
    if (src.indexOf('width=') > -1) return src.replace(/width=\d+/, 'width=700');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('.product-swatches-options__item--swatch') : null;
    if (!sw) return;
    var item = sw.closest('.product-item');
    if (!item) return;
    var thumb = sw.querySelector('img');
    var mainImg = item.querySelector('.product-item__image img, .product-item__media img');
    if (!thumb || !mainImg) return;
    e.preventDefault();
    e.stopPropagation();
    var src = thumb.currentSrc || thumb.src;
    if (!src) return;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('data-srcset');
    mainImg.src = biggerUrl(src);
    item.querySelectorAll('.product-swatches-options__item--swatch').forEach(function (s) {
      s.classList.remove('zv-swatch-selected');
    });
    sw.classList.add('zv-swatch-selected');
  }, true);

  /* cursor-hint */
  var css = document.createElement('style');
  css.textContent = '.product-swatches-options__item--swatch { cursor: pointer; }';
  document.head.appendChild(css);
})();
